import { createSelector } from 'reselect';
import Store, { StoreName, StoreStatusName } from '~/types/Store';
import { ApplicationState } from '../store';

const getStoreIdFromProps = (_: unknown, props: { storeId: string }) => props.storeId;

export const getStoresStore = (state: ApplicationState) => state.stores;

export const getStores = createSelector(getStoresStore, (storesStore) =>
  Object.values(storesStore.data),
);

export const getStoresAllIds = createSelector(getStoresStore, (storesStore) => storesStore.allIds);

export const getStoresIsLoaded = createSelector(
  getStoresStore,
  (storesStore): boolean => storesStore.isLoaded,
);

export const getConnectedStores = createSelector(getStores, (stores) =>
  filterForConnectedStores(stores),
);

export const isWixConnected = createSelector(getConnectedStores, (stores) =>
  isStoreConnected(stores, StoreName.Wix),
);

export const isGodaddyConnected = createSelector(getConnectedStores, (stores) =>
  isStoreConnected(stores, StoreName.Godaddy),
);

export const isEBayConnected = createSelector(getConnectedStores, (stores) =>
  isStoreConnected(stores, StoreName.eBay),
);

const filterForConnectedStores = (stores: Store[]) =>
  stores.filter((store) => store?.status?.name === StoreStatusName.Connected);

const isStoreConnected = (connectedStores: Store[], storeName: string) =>
  !!connectedStores.find((store) => store?.storePlatform?.name === storeName);

export const getStoreById = createSelector(
  getStoresStore,
  getStoreIdFromProps,
  (storesStore, storeId) => storesStore.data[storeId],
);

export const areStoresLoaded = createSelector(
  getStoresStore,
  (storesStore) => storesStore.isLoaded,
);

export const firstConnectedStoreName = createSelector(getConnectedStores, (connectedStores) =>
  connectedStores.length > 0 &&
  connectedStores[0].storePlatform &&
  connectedStores[0].storePlatform.name
    ? connectedStores[0].storePlatform.name
    : '',
);

export const hasStoreConnected = createSelector(
  getConnectedStores,
  (connectedStores) => connectedStores.length > 0,
);

export const isDisconnectingStore = createSelector(
  getStoresStore,
  (storesStore) => storesStore.isDisconnectingStore,
);

export const getConnectedStoresCount = createSelector(
  getConnectedStores,
  (connectedStores): number => connectedStores.length,
);
